import React from 'react';
import AddUserForm from '../../../app/administration/users/components/AddUser';

import EditUserForm from '../../../app/administration/users/components/EditUser';

import ShowUserForm from '../../../app/administration/users/components/ShowUser';
import AddDepartment from '../../../app/administration/department/components/AddDepartment';
import EditDepartment from '../../../app/administration/department/components/EditDepartment';
import PreviewDepartment from '../../../app/administration/department/components/PreviewDepartment';
import DeleteDepartment from '../../../app/administration/department/components/DeleteDepartment';


const modalBody = (caseType) => {
  switch (caseType) {
  
    case 'user':
      return {
        add: AddUserForm,
        edit: EditUserForm,
        show: ShowUserForm,
        delete: null,
      };
      case 'departments':
      return {
        add: AddDepartment,
        edit: EditDepartment,
        show: PreviewDepartment,
        delete: DeleteDepartment,
      };
   
    default:
      return {
        add: null,
        edit: null,
        show: null,
        delete: null,
      };
  }
};

export default modalBody;
